import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/flat",
        component: List,
        name: "flat-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/flat/:id/edit",
        component: Edit,
        name: "flat-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/flat/create",
        component: Create,
        name: "flat-create",
        meta: {
            requiresAuth: true,
        },
    },
];
